<template>
  <div class="min-h-screen bg-gray-50">
    <!-- 主要内容区域 -->
    <div
      class="container mx-auto pt-24 pb-16 px-6"
      :class="{ flexColumn: isMobile }"
    >
      <div
        class="w-full md:w-1/5 bg-white rounded-lg shadow-sm left-list"
        v-if="!isMobile"
      >
        <h4 class="text-1xl font-bold mb-4 padding20">产品中心</h4>
        <ul class="space-y-2">
          <li
            class="padding20"
            @click="toggleActive(1)"
            :class="{ active: activeIndex == 1 }"
          >
            AI智慧驱鸟系统
          </li>
          <li
            class="padding20"
            @click="toggleActive(2)"
            :class="{ active: activeIndex == 2 }"
          >
            城市积水智能监测预警系统
          </li>
          <li
            class="padding20"
            @click="toggleActive(3)"
            :class="{ active: activeIndex == 3 }"
          >
            行业 AI 边缘网关
          </li>
          <li
            class="padding20"
            @click="toggleActive(4)"
            :class="{ active: activeIndex == 4 }"
          >
            软硬件及服务定制内容
          </li>
        </ul>
      </div>
      <div class="mobile-list" v-else>
        <h4
          class="text-1xl font-bold mb-4 padding20"
          style="display: flex; align-items: center"
          @click="isMenuOpen = !isMenuOpen"
        >
          <svg
            t="1745387737042"
            class="icon"
            style="transition: transform 0.3s ease"
            :class="{ rotate: isMenuOpen }"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="10336"
            width="20"
            height="20"
          >
            <path
              d="M512.726547 675.318646c-8.063653 0-15.790638-3.245927-21.435195-9.006118L231.175103 400.906809c-11.603269-11.837606-11.410887-30.840402 0.427742-42.442648 11.837606-11.601222 30.841426-11.410887 42.442648 0.427742l238.681054 243.534596L751.407602 358.891903c11.601222-11.839653 30.602995-12.033058 42.442648-0.427742 11.839653 11.603269 12.031011 30.605042 0.427742 42.442648L534.161742 666.312528C528.517185 672.072719 520.791224 675.318646 512.726547 675.318646z"
              fill="#000000"
              p-id="10337"
            ></path>
          </svg>

          &nbsp; 产品中心
        </h4>
        <ul class="space-y-2" v-if="isMenuOpen">
          <li
            class="padding20"
            @click="toggleActive(1)"
            :class="{ active: activeIndex == 1 }"
          >
            AI智慧驱鸟系统
          </li>
          <li
            class="padding20"
            @click="toggleActive(2)"
            :class="{ active: activeIndex == 2 }"
          >
            城市积水智能监测预警系统
          </li>
          <li
            class="padding20"
            @click="toggleActive(3)"
            :class="{ active: activeIndex == 3 }"
          >
            行业 AI 边缘网关
          </li>
          <li
            class="padding20"
            @click="toggleActive(4)"
            :class="{ active: activeIndex == 4 }"
          >
            软硬件及服务定制内容
          </li>
        </ul>
      </div>
      <div
        class="w-full md:w-4/5 rounded-lg right-content shadow-sm bg-white"
        v-html="richText"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductPage",
  data() {
    return {
      isMobile: false,
      isMenuOpen: false,
      activeIndex: 1, // 当前激活的索引
      richText: "", // 富文本内容
    };
  },
  async created() {
   
     // 初始加载第一个产品内容
     const params = this.$route.query;
     if (params.id){
       this.activeIndex=params.id;
     }
     const response = await fetch(`/product/${this.activeIndex}.text`);
     this.richText = await response.text(); 
      window.scrollTo(0, 0)

  },
  mounted() {

    window.addEventListener("resize", this.checkDeviceType);
    this.checkDeviceType();
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth < 768;
    },
    // 切换激活状态
    async toggleActive(index) {
      this.activeIndex = index;
      this.isMenuOpen = false;
      const response = await fetch(`/product/${index}.text`);
      this.richText = await response.text();
    },
  },
   watch: {
    '$route'(to) {
      if (to.query.id) {
        this.toggleActive(to.query.id);
        window.scrollTo(0, 0)
      }
    }
  }
};
</script>

<style scoped>
.rotate {
  transform: rotate(180deg);
  transition: transform 0.3s ease;
}
.mobile-list {
  margin-bottom: 20px;
}
.flexColumn {
  flex-direction: column;
}
.container {
  /* border: 1px rgb(44, 242, 0) solid; */
  display: flex;
  justify-content: space-between;
}
.left-list {
  /* border: 1px rgb(242, 0, 0) solid; */
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 80vh;
  margin-right: 50px;
}
.padding20 {
  padding-left: 20px;
}
.right-content {
  /* height: 1000px; */
  /* border: 1px pink solid; */
  padding: 20px;
}
li {
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  /* border: 1px rgb(242, 0, 0) solid; */
}
.active {
  background-color: rgb(239, 246, 255); /* 激活时的背景颜色 */
  color: rgb(49, 108, 208); /* 激活时的文本颜色 */
}
</style>
